// extracted by mini-css-extract-plugin
export default {"pagination":"Zkw2gqX_hu4ViEUxEZMn","empty":"SUXfFwl31F_js1oWVlxK","emptyTitle":"qAaQGXuDEZwnR759pc2Q"};